import { render, staticRenderFns } from "./ReportHistoryList.vue?vue&type=template&id=2aa06a30"
import script from "./ReportHistoryList.vue?vue&type=script&lang=js"
export * from "./ReportHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports